import TemplateView from '../../../TemplateView'
import {atImgPath} from '../../../atBrowserUtils'
import {convertLineBreaksToBR} from '../../../util/StringUtils'
import _ from "underscore"

export default class NoteWithIcon extends TemplateView
{

    /**
     *
     * @param text (String|String[]) test to show. May be array -> will be rendered in multiple rows with <br>
     * @param icon
     */
    constructor({
        text = "",
        icon = atImgPath("note_mark.gif")
    } = {}) {
        super();
        this.state = {
            text, icon, textClass: ""
        }
    }


    templateHtml() {
        return `<div class="noteWithIcon noteContainer">
            <img src="<%-state.icon%>" class="noteImage"><span><%=state.text%></span>
        </div>`
    }


    afterRender() {
        this.$image = this.$el.find("img");
        this.$text = this.$el.find("span");

        this.onStatePropertyChanged("text", text => {
            if (_.isArray(text)) {
                text = text.join("\n")
            }
            this.$text.html(convertLineBreaksToBR(text || ''))
        });
        this.onStatePropertyChanged("textClass", textClass => {
            this.$text[0].className = textClass
        });
        this.onStatePropertyChanged("icon", icon => this.$image.attr("src", icon));
    }

    note(text) {
        this.setState({text, icon: atImgPath("note_mark.gif"), textClass: "note notemsg"})
    }

    progress(text) {
        this.setState({text, icon: atImgPath("sending-progress.gif"), textClass: "progress notemsg"})
    }

    success(text) {
        this.setState({text, icon: atImgPath("success.gif"), textClass: "success notemsg"})
    }

}


// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/components/NoteWithIcon.js